<div class="main-container centered" @fadeIn>
    <p><strong>Thank you for using Vitralogy Binder</strong></p>
    <p class="secondary">
        Binder Session Status :
    </p>
    <p class="secondary">
        <span *ngFor="let label of statusLabels" [ngClass]="label.class">
          <ng-container *ngIf="label.class === 'label-green' && isDate(label.text); else otherStatus">
            ACTIVE till {{ label.text | date: 'dd MMM yyyy' }}
          </ng-container>
          <ng-template #otherStatus>{{ label.text }}</ng-template>
        </span>
    </p>
    <p class="secondary">Please contact customer support at Vitralogy for more info</p>
</div>
